import React from "react";
import {
  AiOutlineAntDesign,
  AiOutlineInstagram,
  AiFillGithub,
} from "react-icons/ai";

import { FiFacebook, FiLinkedin } from "react-icons/fi";

const FindMeBestSkillOn = () => {
  return (
    <div>
      <div className="flex mt-10 mb-10">
        {/* <span className="text-sm mb-4 block uppercase sm:mt-0 mt-6 tracking-widest">find with me </span> */}
        <div className="flex  SocialHeroIcons">
          <a
            href="https://www.linkedin.com/in/sohag-zayan/"
            target="_blank"
            className="bg-own-secondary btn-animated-dark   px-4 mr-3   "
          >
            <FiLinkedin className=" text-xl md:text-2xl text-[hsla(210, 50%, 85%, 1)]" />
          </a>
          <a
            href="https://www.facebook.com/sohaghossainzayan"
            target="_blank"
            className="bg-own-secondary btn-animated-dark   md:mx-3 px-4 "
          >
            <FiFacebook className=" text-xl md:text-2xl  text-[hsla(210, 50%, 85%, 1)]" />
          </a>
          <a
            href="https://github.com/sohagmia360"
            target="_blank"
            className="bg-own-secondary btn-animated-dark px-4 md:mx-3 mx-1  "
          >
            <AiFillGithub className=" text-xl md:text-2xl  text-[hsla(210, 50%, 85%, 1)]" />
          </a>
        </div>
      </div>
      <h3 className="-mt-[12px] text-light_white font-light">
        Always Find Me Here for Contact
      </h3>
    </div>
  );
};

export default FindMeBestSkillOn;
